export default __webpack_public_path__ + "static/media/exit.c28aa74c.svg";